import { render, staticRenderFns } from "./LocationAdmin.vue?vue&type=template&id=096dad86&"
import script from "./LocationAdmin.vue?vue&type=script&lang=js&"
export * from "./LocationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdmin.vue?vue&type=style&index=0&id=096dad86&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports